import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import { OAuthModule } from 'angular-oauth2-oidc';
import { SharedModule } from '../shared/shared.module';
import { WpTokenService } from "./auth/wp-token.service";
import { SubStateInterceptor } from "./sub-state.interceptor";

import { InternalRouter } from '../core/router/internal-router.service';
import { InternalOnlyGuard } from '../core/router/internal-only.guard';
import { VerifyWpTokenGuard } from '../core/auth/verify-wp-token.guard';
import { RedirectHomePageGuard } from '../core/auth/redirect-home-page.guard';
import { RedirectLoginPageGuard } from '../core/auth/redirect-login-page.guard';
import { StoreSubStateGuard } from '../core/auth/store-sub-state.guard';
import { GoogleTagService } from './tag/google-tag.service';
import { LogService } from './logger/log.service'
import { DomainProfileGuard } from './router/domain-profile.guard';

import { CookieService } from 'ngx-cookie-service';
import { PixelModule } from 'ngx-pixel-eventid'
 
import { environment } from 'src/environments/environment';
import { GlobalErrorHandler } from './global-error-handler';

@NgModule({ exports: [], imports: [
        CommonModule,
        OAuthModule.forRoot(),
        SharedModule,
        PixelModule.forRoot({ enabled: false, pixelId: environment.facebook_pixel_config })
    ], providers: [
        CookieService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SubStateInterceptor,
            multi: true
        },
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler
        },
        WpTokenService,
        InternalRouter,
        InternalOnlyGuard,
        VerifyWpTokenGuard,
        RedirectHomePageGuard,
        RedirectLoginPageGuard,
        StoreSubStateGuard,
        GoogleTagService,
        LogService,
        DomainProfileGuard,
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class CoreModule { }
